export class TestModule {

	constructor() {
		this.init();
	}

	init() {
		console.log("Running");
	}
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/TestModule.js